var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorIconRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    className: "absolute top-0",
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8478 29.7739C14.4001 29.7739 14.8478 29.3262 14.8478 28.7739C14.8478 28.2216 14.4001 27.7739 13.8478 27.7739V29.7739ZM2.15222 1.22656V0.226562H0.152222V1.22656H2.15222ZM13.8478 28.7739V27.7739H5.15222V28.7739V29.7739H13.8478V28.7739ZM1.15222 24.7739H2.15222V1.22656H1.15222H0.152222V24.7739H1.15222ZM5.15222 28.7739V27.7739C3.49537 27.7739 2.15222 26.4308 2.15222 24.7739H1.15222H0.152222C0.152222 27.5353 2.3908 29.7739 5.15222 29.7739V28.7739Z",
    fill: "#D5D7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIconRight);
export default __webpack_public_path__ + "static/media/vectorIconRight.9415d20222abe8a914d92b52faad9061.svg";
export { ForwardRef as ReactComponent };